import React, { useState } from 'react';
import { BarChartOutlined, TeamOutlined } from '@ant-design/icons';

import {
  Breadcrumb,
  Layout,
  theme,
  Grid,
  Button,
  Avatar,
  Dropdown,
  Space,
  Spin,
  message
} from 'antd';

import { useNavigate, Link, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const { Header, Content } = Layout;
const { useBreakpoint } = Grid;

const PanelAdmin = () => {
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);

  // Traemos del contexto: user, logout (función), loading (estado global de auth)
  const { user, logout, loading } = useAuth();

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const screens = useBreakpoint();

  // Maneja cierre de sesión usando la función del contexto
  const handleLogout = async () => {
    try {
      setLoggingOut(true);
      await logout();
      navigate('/login');
    } catch (err) {
      console.error('Error al cerrar sesión', err);
      message.error('No se pudo cerrar sesión. Intente nuevamente.');
    } finally {
      setLoggingOut(false);
    }
  };

  // Menu para el avatar (usa onClick en el objeto para mantener simple)
  const avatarMenu = {
    items: [
      {
        key: 'perfil',
        label: <Link to="/perfil">Mi perfil</Link>,
        disabled: loading || loggingOut,
      },
      {
        key: 'logout',
        label: 'Cerrar sesión',
        onClick: handleLogout,
        disabled: loading || loggingOut,
      },
    ],
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* HEADER */}
      <Header
        className="admin-panel-header"
        style={{
          padding: '0 16px',
          background: "linear-gradient(135deg, #363683 0%, #d62874 100%)",
        }}
      >
        <div className="admin-panel-brand">
          Panel Admin
        </div>

        <Space size="middle" className="admin-panel-actions">
          <Link to="/admin/dashboard">
            <Button type="text" icon={<BarChartOutlined />} style={{ color: '#fff' }}>
              Dashboard
            </Button>
          </Link>

          <Link to="/admin/users">
            <Button type="text" icon={<TeamOutlined />} style={{ color: '#fff' }}>
              Usuarios
            </Button>
          </Link>

          <Dropdown menu={avatarMenu} placement="bottomRight" arrow>
            <Space className="admin-panel-user-trigger">
              <span style={{ marginRight: 8 }}>¡Hola! Administrador</span>

              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {(loading || loggingOut) ? (
                  <Spin size="small" />
                ) : null}

                <Avatar
                  size="large"
                  style={{
                    backgroundColor: user?.avatarbackground || '#ffffff',
                    color: '#000',
                    fontWeight: 'bold',
                    fontSize: 24,
                  }}
                >
                  {(!user?.avatar && user?.name  && user?.lastName)
                    ? user?.name.charAt(0).toUpperCase()
                    : null}
                </Avatar>
              </div>
            </Space>
          </Dropdown>
        </Space>
      </Header>
      {/* CONTENIDO */}
      <Layout style={{ padding: screens.md ? '0 24px 24px' : 0 }}>
        <Breadcrumb
          items={[{ title: '' }]}
          style={{ margin: screens.md ? '16px 0' : 0 }}
        />

        <Content
          style={{
            padding: screens.md ? 24 : 0,
            margin: 0,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default PanelAdmin;
